import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  padding-bottom: var(--fd-space-space-5);

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;

export const Row = styled.div<{
  isSingleSelection?: boolean;
}>`
  display: flex;

  &:not(:first-child) {
    padding-top: var(--fd-space-space-4);

    @media screen and ${breakpoints.tablet.max.sm} {
      padding-top: var(--fd-space-space-2);
    }
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: var(--fd-space-space-2) var(--fd-space-space-2)
      var(--fd-space-space-2) 0;
    border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
    justify-content: space-between;
    ${({ isSingleSelection }) =>
      !isSingleSelection &&
      css`
        flex-direction: column;
      `}
  }
`;

export const RunnerInfo = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: var(--fd-space-space-2);

  @media screen and ${breakpoints.tablet.max.sm} {
    justify-content: center;
    row-gap: var(--fd-space-space-1);
    padding-top: var(--fd-space-space-3);
  }
`;

export const ContainerPickNumber = styled.div<{ isScratched: boolean }>`
  min-width: 90px;
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
    `}
`;

export const HorseNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const CommentContainer = styled.div<{ isScratched: boolean }>`
  padding-right: var(--fd-space-space-1);
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
    `}
`;

export const BetButtonsContainer = styled.div<{
  isSingleSelection?: boolean;
}>`
  display: inline-block;
  padding-left: var(--fd-space-space-3);
  margin: auto 0;
  flex-shrink: 0;

  @media screen and ${breakpoints.tablet.max.sm} {
    ${({ isSingleSelection }) =>
      !isSingleSelection &&
      css`
        padding: var(--fd-space-space-3) 0 0 var(--fd-space-space-1);
      `}
    & > div > div:first-child {
      flex-grow: 1;
    }

    & > div > div:last-child:not(:only-child) {
      margin-left: var(--fd-space-space-1);
    }
  }
`;

export const ScrLabelContainer = styled.div`
  padding-left: var(--fd-space-space-3);
  margin: auto 0;
`;

export const ContainerRunnerInfo = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
`;
